export default __webpack_public_path__ + "static/media/pinkFloyd.b96f0364.jpg";